import '@lottiefiles/lottie-player'
import '@lottiefiles/lottie-interactivity'

import * as Turbo from '@hotwired/turbo'
Turbo.start()

import "./controllers"
